// extracted by mini-css-extract-plugin
export default {"column-account__container":"styles_column-account__container__VSmNj","column-account__text":"styles_column-account__text__Si8sI"};